export const MAX_COUNT_FILES_TO_UPLOAD = 10;
export const MAX_COUNT_FILES_TO_CREATE = 5;

export const isAdmin = (user) => {
  return (
    user.email === 'lucagiacomelli1604@gmail.com' ||
    user.email === 'matteo.trentini1@gmail.com' ||
    user.email === 'founders.relyant@gmail.com' ||
    user.email.endsWith('relyant.ai')
  );
};
